declare global {
  interface Window {
    DANCECARD_LEAD_NURTURING_CHATBOT_INTEGRATION_ID?: string;
  }
}

const devIntegrationId = '0e30b953-38dc-4acb-9906-e836788a2bf8';

const regexScriptUrl = /\.dancecardrx\.com\/([a-z0-9]{8}\-[a-z0-9]{4}\-[a-z0-9]{4}\-[a-z0-9]{4}\-[a-z0-9]{12})\/main.js/;

export function getIntegrationIdFromScript(): string | null {
  const windowScripts = Array.from(window.document.scripts);
  const widgetSrc = windowScripts.map(a => a.src).find(a => regexScriptUrl.test(a));
  if (!widgetSrc) {
    console.error('No dancecard-leadnurturing-chatbot script in window');
    return null;
  }
  const widgetSrcArray = regexScriptUrl.exec(widgetSrc);

  return widgetSrcArray && widgetSrcArray[1];
}

const prodIntegrationId = window.DANCECARD_LEAD_NURTURING_CHATBOT_INTEGRATION_ID
  ? window.DANCECARD_LEAD_NURTURING_CHATBOT_INTEGRATION_ID
  : getIntegrationIdFromScript();

const integrationId = prodIntegrationId || devIntegrationId;

export default integrationId;
